var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 83,
    viewBox: "0 0 56 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9867 122.462H0M32.9867 111.029H0M32.9867 99.5959H0M32.9867 88.163H0M32.9867 76.7301H0M32.9867 65.2972H0M32.9867 53.8644H0M32.9867 42.4315H0M32.9867 30.9986H0M32.9867 19.5657H0M32.9867 8.13282H0M32.9867 -3.30006H0M32.9867 -14.7329H0M32.9867 -26.1658H0M32.9867 -37.5987H0M32.9867 -49.0316H0M32.9867 -60.4645H0M32.9867 -71.8974H0M32.9867 -83.3303H0M32.9867 -94.7631H0M32.9867 -106.196H0M32.9867 -117.629H0M32.9867 -129.062H0M32.9867 -140.495H0M32.9867 -151.928H0M32.9867 -163.36H0M32.9867 -174.793H0M32.9867 -186.226H0M32.9867 -197.659H0M32.9867 -209.092H0M32.9867 -220.525H0M32.9867 -231.958H0M32.9867 -243.391H0",
    stroke: "#FA0073",
    strokeWidth: 1.46,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3762 76.7109H28.6562",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3762 65.2793H28.6562",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3762 53.8457H28.6562",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3762 42.4141H28.6562",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3762 30.9805H28.6562",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3762 19.5312L28.6562 19.548",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3762 8.09766H28.6562",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkLines);
export default __webpack_public_path__ + "static/media/pink-lines.63f1bf95d880f848508121f1cc966b6f.svg";
export { ForwardRef as ReactComponent };